import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableHead, TableRow } from '@mui/material';
import { MESSAGES } from 'src/constants';

function THeadResults({
  classes,
  currentNavigationTab,
  canShareMessageTemplates = false,
  canEditMessageTemplates = false,
}) {
  const msgTitle = () => {
    switch (currentNavigationTab) {
      case MESSAGES.MESSAGE_TAB_SYSTEM:
        // return 'Msg #';
        return 'Template #';

      case MESSAGES.MESSAGE_TAB_USER:
        return 'Template #';

      default:
        return '';
    }
  };

  return (
    <TableHead className={classes.tableHead}>
      <TableRow>
        <TableCell
          align="left"
          className={classes.msgNum}
        >
          {msgTitle()}
        </TableCell>
        <TableCell
          align="left"
          className={classes.scenario}
        >
          Scenario
        </TableCell>
        {/* CON-1621 — where the template can be used, derived from its
            Smart Field tokens */}
        <TableCell
          align="left"
          className={classes.contextScope}
        >
          Where To Use
        </TableCell>
        <TableCell className={classes.textMessages}>
          Text Message To Send
        </TableCell>
        <TableCell
          align="left"
          className={classes.image}
        >
          Attachments
        </TableCell>
        {/* CON-1625 — Share Code is dark until SHARE_MESSAGE_TEMPLATES is
            granted per-user. The actions column (Duplicate) rides ordinary
            CRUD instead, so a user can have one column without the other.
            These two conditions MUST stay identical to the cells rendered in
            TBodyResultsMessage or the table misaligns. */}
        {canShareMessageTemplates && (
          <TableCell align="left" className={classes.shareCode}>
            Share Code
          </TableCell>
        )}
        {canEditMessageTemplates && (
          <TableCell align="left" className={classes.actions}>
            Actions
          </TableCell>
        )}
      </TableRow>
    </TableHead>
  );
}

THeadResults.propTypes = {
  classes: PropTypes.object.isRequired,
  currentNavigationTab: PropTypes.string.isRequired,
  canShareMessageTemplates: PropTypes.bool,
  canEditMessageTemplates: PropTypes.bool,
};

export default THeadResults;
